import { ApolloError, SubscribeToMoreOptions, useQuery } from "@apollo/client";
import { ProcessStatusData, ProcessStatusReturn } from "src/models/ProcessStatus";
import { GET_PROCESS_STATUS } from "src/operations/queries/getProcessStatus";

export function useProcessStatus(
    requestSysId: string | undefined
): [
    ProcessStatusData | null,
    boolean,
    ApolloError | undefined,
    <TSubscriptionData = ProcessStatusReturn, TSubscriptionVariables = Record<string, any>>(
        options: SubscribeToMoreOptions<ProcessStatusReturn | undefined, TSubscriptionVariables, TSubscriptionData>
    ) => () => void
] {
    const { subscribeToMore, data, loading, error } = useQuery<ProcessStatusReturn>(GET_PROCESS_STATUS, {
        variables: {
            params: {
                requestSysId: requestSysId
            }
        },
        skip: !requestSysId
    });
    // !todo: fix subscribeToMoreData type
    return [data ? (data.processStatus as ProcessStatusData) : null, loading, error, subscribeToMore as any];
}
